import { render } from "./SettingsBG.vue?vue&type=template&id=1adb8e9c&ts=true"
import script from "./SettingsBG.vue?vue&type=script&lang=ts"
export * from "./SettingsBG.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./SettingsBG.vue?vue&type=style&index=0&id=1adb8e9c&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__